import { render } from "./ReportBillingView.vue?vue&type=template&id=52350d22&scoped=true"
import script from "./ReportBillingView.vue?vue&type=script&lang=js"
export * from "./ReportBillingView.vue?vue&type=script&lang=js"

import "./ReportBillingView.vue?vue&type=style&index=0&id=52350d22&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52350d22"]])

export default __exports__